import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: transparent linear-gradient(0deg, #FFB908 0%, #FFB30C 34%, #FF6A40 100%) 0% 0% no-repeat padding-box;

  overflow: hidden;
  height: calc(100vh - 69px);
  width: 100vw;
`;

export const Brain = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-around;
  width: 100%;
  padding-bottom: 32px;

  ${MediaQueries.mobile`
    display: none;
  `}
  
`;
